import Vue from 'vue';
import { lengthDirX, lengthDirY } from 'framework/utils/math-utils';

export default Vue.extend({
  props: {
    progress: Number,
  },
  computed: {
    style(): string {
      const baseStyle = "pointer-events: none;";
      if (this.progress === 1) return baseStyle;
      const angle = this.progress * 360;

      const polygons: Array<[number, number]> = [[0.5, 0.5]];
      const segments = 20;

      for (let i = 0; i <= segments; i++) {
        const currentAngle = (angle * (i / segments));
        polygons.push([
          0.5 + lengthDirX(currentAngle - 90, 0.6, false),
          0.5 + lengthDirY(currentAngle - 90, 0.6, false),
        ]);
      }

      const path = polygons.map(([x, y]) => `${x * 100}% ${y * 100}%`);
      return `${baseStyle} clip-path: polygon(${path});`;
    },
  },
  render() {
    return <div style={this.style}></div>;
  },
});
